/**
 * Centralizamos las peticiones con Axios como cliente http basado en promesas, 
 * permitiendo interceptar las solicitudes y personalizarlas de acuerdo a la necesidad  
 */
import axios from 'axios';

/** Default config for axios instance */
let config = {
	baseURL: ''
};

/** Creating the instance for axios */
const HttpClientAxios = axios.create(config);

/** Auth token interceptors */
const authInterceptor = config => {

	if (HttpClientAxios.defaults.JWT.hasToken() && config.url.indexOf('authorization/oauth/token') == -1) {
		config.headers.Authorization = `Bearer ${HttpClientAxios.defaults.JWT.getToken()}`;
	}

	return config;
};

/** logger interceptors */
const loggerInterceptor = config => {
	/** TODO */
	return config;
}

/** Adding the request interceptors */
HttpClientAxios.interceptors.request.use(authInterceptor);
HttpClientAxios.interceptors.request.use(loggerInterceptor);

/** Adding the response interceptors */
HttpClientAxios.interceptors.response.use(
	response => {
		/** TODO: Add any response interceptors */
		return response;
	},
	error => {

		/*// Return any error which is not due to authentication back to the calling service
		if (error.response.status !== 401) {
			return new Promise((resolve, reject) => {
				reject(error);
			});
		}

		// Logout user if token refresh didn't work or user is disabled
		if (error.config.url == '/api/token/refresh' || error.response.message == 'Account is disabled.') {

			localStorage.removeItem(TokenStorage.USER_TOKEN);
			localStorage.removeItem(TokenStorage.USER_REFRESH_TOKEN)
			router.push({
				name: 'root'
			});

			return new Promise((resolve, reject) => {
				reject(error);
			});
		}

		// Try request again with new token
		return TokenStorage.getNewToken()
			.then((token) => {

				// New request with new token
				const config = error.config;
				config.headers['Authorization'] = `Bearer ${token}`;

				return new Promise((resolve, reject) => {
					axios.request(config).then(response => {
						resolve(response);
					}).catch((error) => {
						reject(error);
					})
				});

			})
			.catch((error) => {
				Promise.reject(error);
			});*/
		/** TODO: Do something with response error */
		return Promise.reject(error);
	}
);

export default HttpClientAxios;